import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user,  setUser]  = useState(() => {
    const stored = localStorage.getItem('hive_user');
    return stored ? JSON.parse(stored) : null;
  });

  // Restore user from API on refresh if token present but user not yet loaded
  useEffect(() => {
    if (token && !user) {
      api.get('/api/me').then(r => {
        setUser(r.data);
        localStorage.setItem('hive_user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('hive_user');
        setToken(null);
      });
    }
  }, []);

  const login = async (username, password) => {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    const res = await api.post('/api/login', params);
    const { access_token } = res.data;
    localStorage.setItem('token', access_token);
    setToken(access_token);
    const me = await api.get('/api/me', {
      headers: { Authorization: `Bearer ${access_token}` },
    });
    setUser(me.data);
    localStorage.setItem('hive_user', JSON.stringify(me.data));
    return me.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('hive_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
